import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from "react-select";
import { selectStyles } from "../helper/SelectStyles";
import { useNavigate } from "react-router-dom";
import TablePagination from "./TablePagination";

const BookedReportLayer = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        expoName: null,
        eventManager: null,
    });

    const [reportData, setReportData] = useState([
        { roNumber: "RO-2026-001", companyName: "Innovate Inc", bookedAmount: "50000", sTax: "9000", total: "59000", stallNo: "A12", ss: "Double", sqtMeter: "12", eventManager: "Admin User", balance: "0", tds: "500" },
        { roNumber: "RO-2026-002", companyName: "Global Logistics", bookedAmount: "35000", sTax: "6300", total: "41300", stallNo: "B05", ss: "Single", sqtMeter: "9", eventManager: "Admin User", balance: "5000", tds: "350" }
    ]);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [totalRecords, setTotalRecords] = useState(2);

    const expoOptions = [
        { value: "expo1", label: "Global Trade Fair 2026" },
        { value: "expo2", label: "Tech Expo 2026" },
    ];

    const managerOptions = [
        { value: "manager1", label: "Admin User" },
        { value: "manager2", label: "Sales Lead" },
    ];

    const handleSelectChange = (selectedOption, field) => {
        setFormData((prev) => ({
            ...prev,
            [field]: selectedOption,
        }));
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div
                className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between"
                style={{ background: "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)" }}
            >
                <h6 className="text-white pb-2 mb-0 uppercase tracking-wider">BOOKED REPORT</h6>
                {/* <button 
                    onClick={() => navigate(-1)} 
                    className="btn btn-sm d-flex align-items-center gap-2 text-white" 
                    style={{ backgroundColor: "rgba(255,255,255,0.2)", border: "1px solid white" }}
                >
                    <Icon icon="solar:alt-arrow-left-bold" />
                    Back
                </button> */}
            </div>
            <div className="card-body p-24">
                <div
                    className="p-24 radius-12 mb-24"
                    style={{ backgroundColor: "#f7e7da" }}
                >
                    <div className="row g-3 align-items-end">
                        <div className="col-md-5">
                            <label className="form-label fw-semibold text-secondary-light">
                                Expo Name :
                            </label>
                            <Select
                                options={expoOptions}
                                styles={selectStyles()}
                                value={formData.expoName}
                                onChange={(opt) => handleSelectChange(opt, "expoName")}
                                placeholder="-- Select --"
                            />
                        </div>
                        <div className="col-md-5">
                            <label className="form-label fw-semibold text-secondary-light">
                                Event Manager :
                            </label>
                            <Select
                                options={managerOptions}
                                styles={selectStyles()}
                                value={formData.eventManager}
                                onChange={(opt) => handleSelectChange(opt, "eventManager")}
                                placeholder="-- Select --"
                            />
                        </div>
                        <div className="col-md-2 mt-16">
                            <button
                                type="button"
                                className="btn btn-warning px-32 py-10 radius-8 d-flex align-items-center gap-2"
                                style={{ backgroundColor: "#ed1c24", border: "none" }}
                            >
                                <Icon icon="solar:printer-bold" className="text-xl" />
                                Print
                            </button>
                        </div>
                    </div>
                </div>

                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr style={{ backgroundColor: "#f7e7da" }}>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Ro Number</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Company Name</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Booked Amount (Rs.)</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>S.Tax (Rs.)</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Total (R.s)</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Stall no</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>SS</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Sqt.meter</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Event Manager</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Balance (Rs.)</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>TDS (R.s)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportData.length > 0 ? (
                                reportData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.roNumber}</td>
                                        <td>{item.companyName}</td>
                                        <td>{item.bookedAmount}</td>
                                        <td>{item.sTax}</td>
                                        <td>{item.total}</td>
                                        <td>{item.stallNo}</td>
                                        <td>{item.ss}</td>
                                        <td>{item.sqtMeter}</td>
                                        <td>{item.eventManager}</td>
                                        <td>{item.balance}</td>
                                        <td>{item.tds}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="11" className="text-center py-24 text-secondary-light font-medium">
                                        No data available in table
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <TablePagination
                    currentPage={currentPage}
                    totalPages={Math.ceil(totalRecords / rowsPerPage)}
                    onPageChange={(page) => setCurrentPage(page)}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(e) => {
                        setRowsPerPage(Number(e.target.value));
                        setCurrentPage(0);
                    }}
                    totalRecords={totalRecords}
                />
            </div>
        </div>
    );
};

export default BookedReportLayer;


